export class BaseStore {
  /**
   * Returns the name of the store
   */
  get name(): string {
    return this.constructor.name;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/store/base/base-store.ts